import { render, staticRenderFns } from "./SystemBackup.vue?vue&type=template&id=98d28f6a&scoped=true"
import script from "./SystemBackup.vue?vue&type=script&lang=js"
export * from "./SystemBackup.vue?vue&type=script&lang=js"
import style0 from "./SystemBackup.vue?vue&type=style&index=0&id=98d28f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d28f6a",
  null
  
)

export default component.exports